/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface TenantEmailSettingsDto
 */
export interface TenantEmailSettingsDto {
    /**
     * 
     * @type {string}
     * @memberof TenantEmailSettingsDto
     */
    defaultFromAddress: string;
    /**
     * 
     * @type {string}
     * @memberof TenantEmailSettingsDto
     */
    defaultFromDisplayName: string;
    /**
     * 
     * @type {string}
     * @memberof TenantEmailSettingsDto
     */
    smtpHost: string;
    /**
     * 
     * @type {number}
     * @memberof TenantEmailSettingsDto
     */
    smtpPort: number;
    /**
     * 
     * @type {string}
     * @memberof TenantEmailSettingsDto
     */
    smtpUserName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantEmailSettingsDto
     */
    smtpPassword?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TenantEmailSettingsDto
     */
    smtpDomain?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TenantEmailSettingsDto
     */
    smtpEnableSsl?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TenantEmailSettingsDto
     */
    settingsAreProven?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TenantEmailSettingsDto
     */
    useHostDefaultEmailSettings?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TenantEmailSettingsDto
     */
    $type?: TenantEmailSettingsDtoTypeEnum;
}


/**
 * @export
 */
export const TenantEmailSettingsDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedConfigurationTenantsDtoTenantEmailSettingsDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Configuration.Tenants.Dto.TenantEmailSettingsDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type TenantEmailSettingsDtoTypeEnum = typeof TenantEmailSettingsDtoTypeEnum[keyof typeof TenantEmailSettingsDtoTypeEnum];


/**
 * Check if a given object implements the TenantEmailSettingsDto interface.
 */
export function instanceOfTenantEmailSettingsDto(value?: unknown): value is TenantEmailSettingsDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(TenantEmailSettingsDtoTypeEnum)[0];
}

export function TenantEmailSettingsDtoFromJSON(json: any): TenantEmailSettingsDto {
    return TenantEmailSettingsDtoFromJSONTyped(json, false);
}

export function TenantEmailSettingsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantEmailSettingsDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'defaultFromAddress': json['defaultFromAddress'],
        'defaultFromDisplayName': json['defaultFromDisplayName'],
        'smtpHost': json['smtpHost'],
        'smtpPort': json['smtpPort'],
        'smtpUserName': !exists(json, 'smtpUserName') ? undefined : json['smtpUserName'],
        'smtpPassword': !exists(json, 'smtpPassword') ? undefined : json['smtpPassword'],
        'smtpDomain': !exists(json, 'smtpDomain') ? undefined : json['smtpDomain'],
        'smtpEnableSsl': !exists(json, 'smtpEnableSsl') ? undefined : json['smtpEnableSsl'],
        'settingsAreProven': !exists(json, 'settingsAreProven') ? undefined : json['settingsAreProven'],
        'useHostDefaultEmailSettings': !exists(json, 'useHostDefaultEmailSettings') ? undefined : json['useHostDefaultEmailSettings'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function TenantEmailSettingsDtoToJSON(value?: TenantEmailSettingsDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'defaultFromAddress': value.defaultFromAddress,
        'defaultFromDisplayName': value.defaultFromDisplayName,
        'smtpHost': value.smtpHost,
        'smtpPort': value.smtpPort,
        'smtpUserName': value.smtpUserName,
        'smtpPassword': value.smtpPassword,
        'smtpDomain': value.smtpDomain,
        'smtpEnableSsl': value.smtpEnableSsl,
        'settingsAreProven': value.settingsAreProven,
        'useHostDefaultEmailSettings': value.useHostDefaultEmailSettings,
        '$type': value.$type,
    });
}

